"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectGroupStatuses = void 0;
// Lifecycle status for a project_group. Two values are sufficient: groups
// don't "complete" or "archive" the way projects do — they exist or they're
// deprecated. Reusing ProjectStatus would create false coupling.
//
// Semantics:
//   ACTIVE   - Default. Group is fully operational. Members can be added,
//              and (once rollout step 3 lands) cross-project subscriptions
//              can be created across its members.
//   INACTIVE - Group is frozen. New project additions and any future
//              cross-project subscriptions are rejected. Existing members
//              and existing subscriptions are NOT auto-evicted; an admin
//              must remove members explicitly. Reactivation is a normal
//              `PUT /project_groups/:id` with `status: 'ACTIVE'`.
const _projectGroupStatuses = ['ACTIVE', 'INACTIVE'];
exports.projectGroupStatuses = _projectGroupStatuses;
//# sourceMappingURL=Index.js.map